import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  attachmentsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  attachmentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
}));
